<template>
    <div class="card background--white">
        <div
            v-if="hasTitle"
            :class="[
                'card__title card--padding color--dark capitalize',
                { 'card__title--margin': addMargins }
            ]"
        >
            <slot name="card__title" />
        </div>
        <div
            :class="[
                'card__body position--relative',
                { 'card--padding': addMargins },
                { 'card--body-full-height': bodyFullHeight },
            ]"
        >
            <slot name="card__body" />
        </div>
    </div>
</template>

<script>
// packages
import { computed } from '@vue/composition-api';

export default {
    props: {
        addMargins: {
            type: Boolean,
            default: true
        },
        bodyFullHeight: {
            type: Boolean,
            default: false
        }
    },
    setup ( _, { slots }) {
        // validação se o card tem titulo.
        const hasTitle = computed( () => slots.card__title );

        return { hasTitle };
    }
};
</script>

<style lang="scss">
    .card {
        width: 100%;
        padding: 30px 0;
        @include rounded-corner( 22px );
        @include box-shadow( 0 9px 30px #00000012 );
        &--padding {
            padding: $card-spacing;
        }
        &--full-grid {
            grid-column: 1 / -1;
        }
        &__title {
            @include typography-specs( 25px, 33px, 700 );
            border-bottom: 1px solid $color-black-light;
            padding-bottom: 11px;
            &--margin {
                margin-bottom: $card-space-between-header-body;
            }
        }
        &--body-full-height {
            height: 100%;
        }
    }
</style>